import { useQuery } from '@tanstack/react-query';
import type { FiscalStatusDTO } from '@bifeai/shared';
import { api } from './api';
import { useSession } from './session';

/** Si esta caja puede facturar (facturación ARCA) y cómo. */
export function useFiscalStatus() {
  const { me } = useSession();
  return useQuery({
    queryKey: ['fiscal', 'status'],
    queryFn: () => api.get<FiscalStatusDTO>('/fiscal/status'),
    enabled: me.tenant.modules.includes('ARCA'),
    staleTime: 60_000,
  });
}
